import type { Locale } from "../../I18n";

/**
 * Builds the Indeed Resume builder URL for the seeker's current locale.
 *
 * Shared across features (e.g. the profile resume tab's build CTA, viewjob's gated
 * Match Overview), which is why it lives here rather than in either feature's config.
 */
export const getResumeBuilderUrl = (profileBaseUrl: string, { language, country }: Locale) => {
  const localeParams = [`hl=${encodeURIComponent(language)}`];
  if (country) {
    localeParams.push(`co=${encodeURIComponent(country)}`);
  }

  return `${profileBaseUrl}/build?${localeParams.join("&")}`;
};
